import { GET, POST, PATCH, DELETE } from "../config";

export const list = async (page, filters = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);

  if (filters.branch) params.append("branch__in", filters.branch);
  if (filters.client) params.append("client__in", filters.client);
  if (filters.status) params.append("status__in", filters.status);
  if (filters.date_from) params.append("date__gte", filters.date_from);
  if (filters.date_to) params.append("date__lte", filters.date_to);

  const response = await GET(`sales/quotations/?${params.toString()}`);
  return response.data;
};

export const create = async (values) => {
  const response = await POST("sales/quotations/", values);
  return response;
};

export const update = async (id, data) => {
  const response = await PATCH(`sales/quotations/${id}/`, data);
  return response;
};

export const destroy = async (id) => {
  const response = await DELETE(`sales/quotations/${id}/`);
  return response;
};

export const get_stats = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.branch) params.append("branch", filters.branch);

  const response = await GET(`sales/quotations/stats/?${params.toString()}`);
  return response.data;
};

export const convertToOrder = async (id) => {
  const response = await POST(`sales/quotations/${id}/convert_to_order/`);
  return response.data;
};

export const retrieve = async (id) => {
  const response = await GET(`sales/quotations/${id}/`);
  return response.data;
};
